// @ts-nocheck

import { createContext, useContext } from 'react';

type BetslipOptionsContextProps = {
  betslipRef?: string;
  betslipId?: string;
  uuid?: string;
  onCloseModal?: () => void;
  isFromHistory?: boolean;
};

export const BetslipOptionsContext = createContext<BetslipOptionsContextProps>({});

export const useBetslipOptionsContext = () => useContext(BetslipOptionsContext);
